module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "downloadsCat"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "cat-view"
  }, [_c('div', {
    staticClass: "cat-bg",
    style: ('background-image: url(' + _vm.data.cat.image + ');')
  }, [_c('div', {
    staticClass: "cat"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.data.cat.name,
      "subTitle": _vm.data.cat.desc,
      "titleClass": "largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.data.downloads), function(download, index) {
    return _c('mu-list-item', {
      key: ("download-" + index),
      staticClass: "item",
      attrs: {
        "title": download.title,
        "describeText": download.desc
      },
      on: {
        "click": function($event) {
          return _vm.openLink(download)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "src": download.image_url
      }
    })], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('mu-icon', {
      attrs: {
        "value": "file_downloads",
        "color": "#0179d5"
      }
    })], 1), _vm._v(" "), _c('mu-divider')], 1)
  }), 1)], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.data.cat.name)
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc",
    domProps: {
      "textContent": _vm._s(_vm.data.cat.desc)
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-766e56e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Downloads/DownloadsCategory.vue
// module id = 3788
// module chunks = 1